export const getClassByVariant = (variant: string) => {
  switch (variant) {
    case "secondary":
      return {
        label: "text-tertiary",
        input: "bg-icon/20"
      };

    case "primary":
      return {
        label: "text-tertiary",
        input: "bg-input"
      };

    default:
      return null;
  }
};

export const getClassByStatus = (status: string) => {
  switch (status) {
    case "Pending":
    case "Pending Originals":
    case "Special Pending":
      return "text-pendingBorder";

    case "Pending Delivery":
    case "Declined":
    case "Incomplete":
      return "text-declinedBorder";

    case "Pending NOA":
    case "Remote Approved":
    case "Paid":
    case "Carrier Paid":
    case "Invoice Paid":
    case "Approved":
      return "text-approvedBorder";

    case "Document Review":
      return "text-info";

    case "Non Factored":
    case "Document Issue":
      return "text-subtitle";

    default:
      return "text-pendingBorder";
  }
};
